// extracted by mini-css-extract-plugin
export default {"showActions":"style_showActions__A0Siq","productCard":"style_productCard__ln611"};